var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import others from '../../../ts/others';
import mosaicTransfer from '../../../ts/mosaicTransfer';
// コンポーネントの設定
var MyPage = /** @class */ (function (_super) {
    __extends(MyPage, _super);
    function MyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.others = new others();
        _this.address = _this.others.mosaicTransfer.address;
        return _this;
    }
    MyPage.prototype.updateStatus = function () {
        var _this = this;
        this.others.getUserInfofromAPI()
            .then(function (result) {
            console.log(result);
            _this.others.helper.save("User-Info", result);
            _this.others.setVar(result);
        });
    };
    MyPage = __decorate([
        Component({
            name: 'my_page',
            methods: {},
            data: function () { return ({
                user_title: "ユーザー情報",
                uq_title: "有給取得情報",
                balance_text: "取得可能な有給",
                sum_text: "合計申請時間",
                carry_over_text: "来年度繰越可能",
                expiration_text: "うち今年度で失効",
                uq: "UQ",
                recieve_text: "受取履歴",
                mosaic: new mosaicTransfer(),
            }); }
        })
    ], MyPage);
    return MyPage;
}(Vue));
export default MyPage;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/details/MyPage.vue
// module id = 266
// module chunks = 1